import { render, staticRenderFns } from "./AppointmentCardList.vue?vue&type=template&id=64dd5a17&scoped=true&"
import script from "./AppointmentCardList.vue?vue&type=script&lang=js&"
export * from "./AppointmentCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dd5a17",
  null
  
)

export default component.exports